export default {
  title: '素材库',
  tabImage: '图片',
  tabVideo: '视频',
  allGroups: '全部分组',
  addGroup: '添加分组',
  editGroup: '编辑分组',
  deleteGroup: '删除分组',
  groupName: '分组名称',
  groupNamePlaceholder: '请输入分组名称',
  confirmDeleteGroup: '确认删除该分组吗？删除后分组下的素材将移至未分组。',
  upload: '上传图片',
  uploadVideo: '上传视频',
  batchGroup: '批量分组',
  batchDelete: '批量删除',
  searchName: '图片名称',
  searchNamePlaceholder: '请输入名称',
  selected: '已选',
  item: '项',
  cancelSelect: '取消选择',
  preview: '预览',
  copyLink: '复制链接',
  confirmDelete: '确认删除选中的素材吗？',
  confirmDeleteSingle: '确认删除该素材吗？',
  copySuccess: '链接已复制',
  moveSuccess: '移动成功',
  uploadSuccess: '上传成功',
  uploadTitle: '上传素材',
  dragTip: '点击或拖拽文件到此区域上传',
  uploadLimit: '支持 JPG、PNG、GIF 格式，单张不超过 5MB',
  uploadVideoLimit: '支持 MP4、AVI 格式，单个不超过 500MB',
  editTitle: '编辑素材',
  materialName: '素材名称',
  materialNamePlaceholder: '请输入素材名称',
  moveGroupTitle: '移动到分组',
  targetGroup: '目标分组',
  selectGroupPlaceholder: '请选择分组',
  ungrouped: '未分组',
  emptyImage: '暂无图片',
  emptyVideo: '暂无视频',
  uploadNow: '立即上传',
  videoCover: '视频封面',
  uploadCover: '上传封面',
  uploadFile: '上传文件',
  uploadFileRequired: '请选择要上传的文件',
  videoCoverRequired: '请上传视频封面',
  fileSizeExceed: '文件大小超过 {max}',
};
